
import { Component, Prop, Vue } from "vue-property-decorator";
import CustomChipLink from "@/components/CustomChipLink.vue";
import { Getter } from "vuex-class";
import KeyCreate from "@/components/keys/KeyCreate.vue";

@Component({
  components: { KeyCreate, CustomChipLink },
})
export default class BuildingKeys extends Vue {

  @Getter private canDoInEnvCompany: (right: string) => boolean;

  @Getter private envCompanyId: number | null;
  @Getter private envCompany: number | null;
  @Getter private isMobile: boolean;
  @Getter private isAdmin: boolean;
  @Prop()
  private readonly building: any;
  private keysLoading: boolean = false;
  private linkedKeys: any[] = [];
  private showCreateDialog: boolean = false;
  private showArchivedKeys: boolean = false;

  private linkedKeysHeaders: object[] = [
    { value: "name", sortable: false },
  ];

  /**
   * Performs necessary operations when the component is mounted.
   *
   * @private
   * @memberof ComponentName
   *
   * @returns {void}
   */
  private mounted() {
    this.reset();
  }

  /**
   * Resets the state by fetching linked keys based on the building ID.
   *
   * @return {void}
   */
  private reset() {
    this.getLinkedKeysByBuildingId();
  }

  /**
   * Clicks on a row and navigates to a specific route.
   *
   * @param {Object} item - The item associated with the row.
   * @param {number} item.id - The unique identifier of the item.
   *
   * @return {void}
   */
  private clickRow(item) {
    this.$store.dispatch("keys/getById", { id: item?.id, options: {} })
      .then(() => this.$router.push({ name: "key", params: { id: item?.id } }))
      .catch((err) => {
        this.$store.commit("alerts/displayError", {
          msg: this.$t(`alerts.error.${err.response.statusText}`),
        });
      });
  }

  /**
   * Retrieves linked keys by building ID.
   *
   * @private
   * @returns {Promise} A promise that resolves when the linked keys are retrieved.
   */
  private getLinkedKeysByBuildingId() {
    if (this.isAdmin || this.canDoInEnvCompany("READ_BUILDING")) {
      this.keysLoading = true;
      const filters = {
        archived: this.showArchivedKeys,
      };
      return this.$store.dispatch("buildings/getLinkedKeysByBuildingId", {
        buildingId: this.building.id,
        query: filters,
      })
        .then((data) => {
          this.linkedKeys = data?.rows || [];
        })
        .finally(() => {
          this.keysLoading = false;
          this.$emit("loaded");
        });
    }
  }

  /**
   * Update the Keys showed when the Archive toggle is clicked
   *
   * @private
   * @return {void}
   */
  private updateShowArchivedKey(): void {
    this.reset();
  }
}
